<template>
  <div class="card-detail">

    <div class="sh_fee card-block">
      <div class="v-title text_gray">Card Name:</div>
      <div class="v-val">{{CardInfo.Title}}</div>
    </div>
    <div class="sh_fee">
      <div class="v-title text_gray">Card No:</div>
      <div class="v-val">{{CardInfo.Code}}</div>
    </div>
    <div class="sh_fee">
      <div class="v-title text_gray">Buy Date:</div>
      <div class="v-val">{{CardInfo.BuyDate}}</div>
    </div>
    <div class="sh_fee">
      <div class="v-title text_gray">Order Total:</div>
      <div class="v-val">$ {{CardInfo.USD_TotalPrice}}</div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'CardDetail',
  data() {
    return {

    }
  },
  props: {
    CardInfo: {}
  },
  watch: {

  },
  created: function () {
    var that = this;
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/card-detail.vue